


















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Levels } from "@/interfaces/general";

@Component({
  components: {},
  computed: {},
  methods: {}
})
export default class LevelHome extends Vue {
  @Prop({ type: Array, required: true }) data!: Levels[];
  level: number = 0;
  labelsLevel: string[] = [
    "Level 1",
    "Level 2",
    "Level 3",
    "Level 4",
    "Level 5",
    "Level 6",
    "Level 7"
  ];

  mounted() {
    this.level = this.data.findIndex(item => item.now);
  }

  get getCurrentLevel(): number {
    return this.data.findIndex(item => item.now);
  }
}
